export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        "Adres serwera": "",
        "Baza danych tego klienta jest nieaktualna.": "",
        "Bazy danych": "",
        "Data dodania": "",
        "Dodaj klienta": "",
        "Dodaj serwer": "",
        "Dodanie klienta": "",
        "Dodanie serwera": "",
        "Dodawanie klienta SaaS": "",
        "Dodawanie serwera bazy danych": "",
        "Dodawanie serwera plików": "",
        "Edycja klienta": "",
        "Edycja klienta SaaS": "",
        "Edycja serwera": "",
        "Edycja serwera bazy danych": "",
        "Edycja serwera plików": "",
        "Edytuj": "",
        "Hasło": "",
        "Hasło (Klucz ukryty)": "",
        "Hasło użytkownika serwisowego": "",
        "Host dodatkowy": "",
        "Host główny": "",
        "Katalog": "",
        "Klienci": "",
        "Klient aktywny": "",
        "Klient został dodany.": "",
        "Klient został usunięty.": "",
        "Klient został zaktualizowany.": "",
        "Kontener plików": "",
        "Migracje": "",
        "Nazwa bazy danych": "",
        "Nazwa klienta": "",
        "Nazwa konta (Klucz dostępu)": "",
        "Nazwa serwera": "",
        "Nazwa użytkownika": "",
        "Nazwa użytkownika serwisowego": "",
        "Nie udało się pobrać listy serwerów baz danych": "",
        "Nie udało się pobrać listy serwerów plików": "",
        "Nie udało się wczytać listy. Spróbuj ponownie.": "",
        "Port": "",
        "Port serwera": "",
        "Potwierdzenie usunięcia": "",
        "Region": "",
        "Serwer bazy danych": "",
        "Serwer dostępny": "",
        "Serwer plików": "",
        "Serwer został dodany.": "",
        "Serwer został usunięty.": "",
        "Serwer został zaktualizowany.": "",
        "Serwery plików": "",
        "Spróbuj ponownie": "",
        "Symbol klienta": "",
        "System": "",
        "Tryb konserwacji systemu": "",
        "Tylko serwer deweloperski. Nie używać w trybie produkcyjnym. ": "",
        "Typ serwera": "",
        "Usługi": "",
        "Ustawienia zaawansowane": "",
        "Usuń": "",
        "Wczytywanie danych…": "",
        "Wybierz serwer": "",
        "Zapisz": "",
        "Zapisz i wróć": ""
    }
};
